<script lang="ts">
	import type { Post } from '$lib/api/rpc';
	import Footer from '$lib/components/Post/PostBlock/Blocks/Footer.svelte';

	export let block: Post;
	export let editable = false;
</script>

<svelte:element
	this={editable ? 'div' : 'a'}
	href={block.source.url}
	target="_blank"
	rel="external">
	<div class="link-container">
		<div class="image">
			<img src={block.title_image?.url} alt={block.title_image?.alt_text} />
		</div>
		<Footer {editable} {block} />
	</div>
</svelte:element>

<style>
	a {
		text-decoration: none;
	}

	.image {
		block-size: 80vw;
		max-block-size: 400px;
		border-radius: 3px;
	}

	img {
		block-size: 100%;
		inline-size: 100%;
		border-radius: 3px;
		object-fit: scale-down;
	}
</style>
